module.exports = __webpack_public_path__ + "static/media/timber05.1710695a.png";